// extracted by mini-css-extract-plugin
export default {"menu":"rJnJ25rVd5YApB2hysB1","link":"toLRHY61pB0NM9i5bjNw"};